import { Component } from 'react';
import styled from 'styled-components';
import { Image } from '../Image/Image';

const ErrorElement = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const HeaderElement = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const DescriptionElement = styled.div`
  color: #647079;
  font-size: 14px;
`;

interface IProps {
  /** Heading text for the error. Defaults to "Something went wrong!". */
  heading?: string;
  /** Optional description of the error. Defaults to undefined. */
  description?: string;
}

export class Error extends Component<IProps> {
  public render() {
    const heading = this.props.heading || 'Something went wrong!';
    return (
      <ErrorElement>
        <Image src="/images/404.svg" />
        <HeaderElement>{heading}</HeaderElement>
        {this.props.description && <DescriptionElement>{this.props.description}</DescriptionElement>}
      </ErrorElement>
    );
  }
}
